import { useTranslation } from "react-i18next";

import { PageContainer } from "../../components/PageContainer";
import { buildWeightHistoryUrl, PREV_PAGE_PARAM } from "../../utils/url";
import { ContainerDetailForm } from "./ContainerDetailForm";

export const ContainerDetailPage = () => {
  const { t } = useTranslation();

  const goToWeightHistory = () => {
    const queryParams = new URLSearchParams(location.search);
    const id = queryParams.get("id");
    const cid = queryParams.get("cid");
    const prevPage = queryParams.get(PREV_PAGE_PARAM);

    return buildWeightHistoryUrl(id!, cid!, { prevPage: prevPage ?? undefined });
  };

  return (
    <PageContainer
      backOption={true}
      backPath={goToWeightHistory()}
      fullHeight={false}
      headerText={t("containerDetail")}
    >
      <ContainerDetailForm />
    </PageContainer>
  );
};
